module.exports = __webpack_public_path__ + "img/img13.005fa0c3.svg";